// DelegationBar.tsx
import { Button } from '@/components/shared/button/Button';
import {
  selectIsDelegatedManager,
  useAuthenticationService
} from '@/services/authentication/authentication-service';
import { useAdminLocationStore } from '@/services/location/useAdminLocationStore';
import React from 'react';
import { MdExitToApp } from 'react-icons/md';
import strings from './tenantManagement.translations';
import { useExitDelegation } from './useExitDelegation';

export const DelegationBar: React.FC = () => {
  const exitDelegation = useExitDelegation();
  const actingLocation = useAdminLocationStore(state => state.actingLocation);
  const { user, isDelegatedManager } = useAuthenticationService(state => ({
    user: state.user,
    isDelegatedManager: selectIsDelegatedManager(state)
  }));

  if (!user?.delegation?.isDelegating) return null;

  const label = isDelegatedManager
    ? actingLocation
      ? strings.locationMimicBar?.editingLocation(actingLocation.name)
      : null
    : strings.delegationBar.actingAs(user.delegation.delegatedTenantName ?? strings.delegationBar.unknownTenant);

  const exitLabel = isDelegatedManager
    ? strings.locationMimicBar?.exit || 'Exit Location Mode'
    : strings.delegationBar.exit;

  if (!label) return null;

  return (
    <div className="bg-secondary-500 text-white px-4 py-3 flex justify-between items-center shadow-md font-medium z-50">
      <span>{label}</span>

      <Button onClick={() => void exitDelegation()} className="flex items-center gap-1">
        <MdExitToApp size={18} />
        {exitLabel}
      </Button>
    </div>
  );
};
